import reviewData from './reviewData';

const root = {
	reviewData
};

export default root;
